(() => {
  const removeLegacyVendorFacets = () => {
    document.querySelectorAll('input[name="filter.p.vendor"]').forEach((input) => {
      const vendor = String(input.value || '').trim().toLowerCase();
      if (vendor === 'stars uniform') return;

      const item = input.closest('.facets__item, .mobile-facets__item, li');
      if (item) item.remove();
    });
  };

  removeLegacyVendorFacets();
  document.addEventListener('DOMContentLoaded', removeLegacyVendorFacets);

  if (document.documentElement) {
    new MutationObserver(removeLegacyVendorFacets).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
  /* ============================================================
     Stars Assistant — lazy chat engine.
     Honest by design: curated answers about THIS store's real
     policies/programs, live catalog search via Shopify's
     predictive search API, and a hand-off to humans when unsure.
     ============================================================ */
  const help = document.querySelector('[data-stars-help]');
  if (!help) return;
  const panel = help.querySelector('[data-stars-help-panel]');
  const toggle = help.querySelector('[data-stars-help-toggle]');
  const closeBtn = help.querySelector('[data-stars-help-close]');
  if (!panel || !toggle) return;

  let engineReady = false;

  const openPanel = () => {
    panel.hidden = false;
    toggle.setAttribute('aria-expanded', 'true');
    help.classList.add('is-open');
    if (!engineReady) { initEngine(); engineReady = true; }
    const input = panel.querySelector('[data-chat-input]');
    if (input) window.setTimeout(() => input.focus(), 220);
  };
  const closePanel = () => {
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    help.classList.remove('is-open');
  };
  toggle.addEventListener('click', () => (panel.hidden ? openPanel() : closePanel()));
  if (closeBtn) closeBtn.addEventListener('click', closePanel);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !panel.hidden) closePanel(); });
  document.addEventListener('click', (e) => {
    if (!panel.hidden && !help.contains(e.target)) closePanel();
  });

  function initEngine() {
    const log = panel.querySelector('[data-chat-log]');
    const form = panel.querySelector('[data-chat-form]');
    const input = panel.querySelector('[data-chat-input]');
    const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    let history = [];
    try { history = JSON.parse(window.sessionStorage.getItem('stars:chat') || '[]'); } catch (e) { history = []; }
    const save = () => {
      try { window.sessionStorage.setItem('stars:chat', JSON.stringify(history.slice(-30))); } catch (e) { /* ignore */ }
    };

    const bubble = (role, html, skipHistory) => {
      const row = document.createElement('div');
      row.className = 'stars-help__msg stars-help__msg--' + role;
      if (role === 'bot') row.innerHTML = '<span class="stars-help__msg-avatar" aria-hidden="true">&#9733;</span><div class="stars-help__msg-body">' + html + '</div>';
      else row.innerHTML = '<div class="stars-help__msg-body">' + html + '</div>';
      log.appendChild(row);
      log.scrollTop = log.scrollHeight;
      if (!skipHistory) { history.push({ r: role, h: html }); save(); }
      return row;
    };

    const typing = () => {
      const row = document.createElement('div');
      row.className = 'stars-help__msg stars-help__msg--bot stars-help__msg--typing';
      row.innerHTML = '<span class="stars-help__msg-avatar" aria-hidden="true">&#9733;</span><div class="stars-help__msg-body"><span class="stars-help__dot"></span><span class="stars-help__dot"></span><span class="stars-help__dot"></span></div>';
      log.appendChild(row);
      log.scrollTop = log.scrollHeight;
      return row;
    };

    const reply = (html, delay) => {
      const t = typing();
      window.setTimeout(() => { t.remove(); bubble('bot', html); }, delay || 550);
    };

    const link = (href, label) => '<a href="' + href + '">' + esc(label) + '</a>';

    const searchProducts = (q) => {
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=hide';
      return fetch(url).then((r) => r.json()).then((d) => (d && d.resources && d.resources.results && d.resources.results.products) || []).catch(() => []);
    };

    const productCards = (items) => {
      let html = '<div class="stars-help__results">';
      items.forEach((p) => {
        const img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        html += '<a class="stars-help__result" href="' + p.url + '">' +
          (img ? '<img src="' + img + '&width=90" alt="" width="45" height="45" loading="lazy" onerror="this.style.display=\'none\'">' : '') +
          '<span><strong>' + esc(p.title) + '</strong><em>' + esc(p.price ? '$' + p.price : '') + '</em></span></a>';
      });
      return html + '</div>';
    };

    const CONTACT = 'Call ' + link('tel:6094755503', '609-475-5503') + ' or email ' + link('mailto:sfuniforms@gmail.com', 'sfuniforms@gmail.com') + ' &mdash; the team reads every message.';

    const INTENTS = [
      { k: ['hi', 'hello', 'hey', 'good morning', 'good afternoon'], a: () => 'Hi! I can search the catalog, explain sizing and shipping, or point you to bulk quotes and custom services. What do you need?' },
      { k: ['thank', 'thanks', 'appreciate'], a: () => 'Happy to help! Anything else you need?' },
      { k: ['bye', 'goodbye', 'see you'], a: () => 'Anytime &mdash; we&rsquo;re here when your team needs gear. &#9733;' },
      { k: ['ship', 'shipping', 'deliver', 'delivery', 'how long', 'arrive'], a: () => 'Eligible orders of $100+ may receive free Standard Shipping (estimated 2&ndash;8 business days) when no other discount is applied. The $2,000+ bulk offer includes both 5% off and free Standard Shipping. Faster and carrier-priced options keep their normal checkout rates. Details are on the ' + link('/policies/shipping-policy', 'shipping policy') + ' page.' },
      { k: ['return', 'refund', 'exchange'], a: () => 'Returns and exchanges are handled through our ' + link('/pages/returns-exchanges', 'Returns &amp; Exchanges') + ' page. Heads up: customized items (badges, engraving, embroidery) may be non-returnable once you approve the design.' },
      { k: ['size', 'sizing', 'fit', 'measurement', 'chest', 'waist', 'how big'], a: () => 'Quick reference &mdash; shirts run XS (32&ndash;34&Prime; chest) to 3XL (50&ndash;52&Prime;); pants waist 28&ndash;50&Prime;. The full charts are on the ' + link('/pages/size-guide', 'Size Guide') + '. Ordering for a team? Send your roster and we&rsquo;ll help build the size run.' },
      { k: ['bulk', 'team order', 'wholesale', 'volume', 'department', 'quote for'], a: () => 'Eligible orders of $2,000+ receive 5% off plus free Standard Shipping (estimated 2&ndash;8 business days). No other discount can be combined with this bulk offer, and faster shipping keeps its normal checkout price. Start at ' + link('/pages/bulk-uniform-orders', 'Request a Bulk Quote') + ' or use the package builder there.' },
      { k: ['badge'], a: () => 'You can design a badge right on the site &mdash; 60 styles, your text on every panel, live preview: ' + link('/pages/design-your-badge', 'Design Your Badge') + '. Custom badge orders typically run 12&ndash;16 weeks after mockup approval.' },
      { k: ['patch', 'patches', 'embroider'], a: () => 'Custom patches start from 14 blank templates or your own artwork &mdash; ' + link('/pages/design-your-patch', 'Design Your Patch') + '. Typical turnaround is 4&ndash;6 weeks after you approve the mockup. Embroidery and silkscreening live under ' + link('/pages/custom-uniform-services', 'Custom Services') + '.' },
      { k: ['nameplate', 'name plate', 'name tag', 'engrav'], a: () => 'Engraved nameplates and name tags: pick a style, add up to 15 characters per line &mdash; ' + link('/pages/design-your-nameplate', 'Design Your Nameplate') + '.' },
      { k: ['deal', 'discount', 'coupon', 'promo', 'offer', 'sale', 'saving'], a: () => 'Current programs include first-order, second-purchase, bulk-order, approved-retail, referral, and Standard Shipping offers when eligible. Discounts do not stack. The only combined offer is for eligible $2,000+ orders: 5% off plus free Standard Shipping. No additional discount can be added. See each program page or ask the team for eligibility details.' },
      { k: ['track', 'order status', 'where is my order', 'my order'], a: () => 'You can check order status in ' + link('/account', 'your account') + '. No account or need a hand? Email ' + link('mailto:sfuniforms@gmail.com', 'sfuniforms@gmail.com') + ' with your order number and we&rsquo;ll look it up.' },
      { k: ['human', 'agent', 'person', 'call', 'phone', 'speak', 'contact', 'support'], a: () => 'I&rsquo;m an automated assistant &mdash; for anything I can&rsquo;t answer, ' + CONTACT },
      { k: ['retail', 'store pricing', 'reseller'], a: () => 'Retail uniform stores get 15% off after approved registration. Only one offer applies per order &mdash; apply at ' + link('/pages/retail-store-pricing', 'Retail Store Program') + '.' },
      { k: ['refer', 'referral'], a: () => 'Verified referral rewards are issued after eligibility review and cannot combine with another offer. See how it works at ' + link('/pages/refer-a-friend', 'Refer a Friend') + '.' },
      { k: ['hour', 'address', 'location', 'where are you'], a: () => 'We&rsquo;re at 2400 Whitehorse Mercerville Road, New Jersey. ' + CONTACT },
      { k: ['america', '250', 'patriotic', 'anniversary', '1776', 'celebration', 'independence'], a: () => 'We&rsquo;re celebrating America&rsquo;s 250th anniversary (1776&ndash;2026) through July 24, 2026 &mdash; patriotic flag patches, emblems and pins, plus custom badge and patch services: ' + link('/pages/america-250', 'America 250 Celebration') + '. Heads up: only specifically marked products or active discounts carry special pricing &mdash; check the product page and cart totals.' },
      { k: ['catalog'], a: () => 'Browse or request the catalog at ' + link('/pages/digital-catalog', 'Digital Catalog') + ', or just tell me what you&rsquo;re looking for and I&rsquo;ll search it.' },
    ];

    const matchIntent = (q) => {
      const lower = ' ' + q.toLowerCase() + ' ';
      let best = null; let bestScore = 0;
      INTENTS.forEach((intent) => {
        let score = 0;
        intent.k.forEach((kw) => { if (lower.indexOf(kw) !== -1) score += kw.length; });
        if (score > bestScore) { bestScore = score; best = intent; }
      });
      return best;
    };

    const respond = (q) => {
      const intent = matchIntent(q);
      if (intent) { reply(intent.a()); return; }
      /* no intent — search the real catalog */
      const t = typing();
      searchProducts(q).then((items) => {
        t.remove();
        if (items.length) {
          bubble('bot', 'Here&rsquo;s what I found in the catalog:' + productCards(items) + '<span class="stars-help__more">' + link('/search?q=' + encodeURIComponent(q), 'See all results &rarr;') + '</span>');
        } else {
          bubble('bot', 'I couldn&rsquo;t find that in the catalog, and I&rsquo;d rather connect you with a person than guess. ' + CONTACT);
        }
      });
    };

    const send = (q) => {
      const clean = q.trim();
      if (!clean) return;
      bubble('user', esc(clean));
      respond(clean);
    };

    form.addEventListener('submit', (e) => { e.preventDefault(); send(input.value); input.value = ''; });
    panel.querySelectorAll('[data-chat-quick]').forEach((chip) =>
      chip.addEventListener('click', () => send(chip.getAttribute('data-chat-quick')))
    );

    /* restore or greet */
    if (history.length) {
      history.forEach((m) => bubble(m.r, m.h, true));
    } else {
      bubble('bot', 'Welcome to Stars Uniform! &#9733; I&rsquo;m an automated assistant &mdash; ask me about products, sizing, shipping, bulk orders, or custom badges &amp; patches. Try a quick topic below or type a question.');
    }
  }
})();
